<div class="photos-modal">
  <div class="photos-modal__header">
    <div class="photos-modal__title-wrap">
      <h3 class="photos-modal__title">{{ title || ('assetShared.attachments.title' | transloco) }}</h3>
      @if (contextLabel) {
        <span class="photos-modal__context-chip">{{ contextLabel }}</span>
      }
    </div>
    <button class="photos-modal__close-btn" (click)="close()" [title]="'common.close' | transloco">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.1959 6.34399L11.9529 10.586L7.71087 6.34399L6.29688 7.75799L10.5389 12L6.29688 16.242L7.71087 17.656L11.9529 13.414L16.1959 17.656L17.6099 16.242L13.3679 12L17.6099 7.75799L16.1959 6.34399Z" fill="#9FA1A4"/>
      </svg>
    </button>
  </div>

  @if (items.length > 0 && currentItem) {
    <div
      class="photos-modal__stage"
      [class.photos-modal__stage--loading]="isMediaLoading"
      #mediaStage>
      @if (isVideo(currentItem)) {
        <video
          #videoPlayer
          class="photos-modal__video"
          [src]="currentItem.url"
          [controls]="!isMediaLoading"
          controlsList="nofullscreen"
          [class.photos-modal__video--loading]="isMediaLoading"
          (loadstart)="markMediaLoading()"
          (waiting)="markMediaLoading()"
          (stalled)="markMediaLoading()"
          (loadeddata)="markMediaReady()"
          (canplay)="markMediaReady()"
          (playing)="markMediaReady()"
          (error)="markMediaReady()">
        </video>
      } @else if (isImage(currentItem)) {
        <img
          class="photos-modal__image"
          [class.photos-modal__image--loading]="isMediaLoading"
          [src]="currentItem.url"
          [alt]="currentItem.name"
          (load)="markMediaReady()"
          (error)="markMediaReady()" />
      } @else {
        <div class="photos-modal__unsupported">
          <i class="ph ph-file"></i>
          <span>{{ 'assetShared.attachments.previewUnavailable' | transloco }}</span>
        </div>
      }

      @if (isMediaLoading) {
        <div class="photos-modal__spinner" [attr.aria-label]="'assetShared.attachments.loadingPreview' | transloco">
          <span class="photos-modal__spinner-ring"></span>
        </div>
      }

      <button class="photos-modal__download-single" (click)="downloadItem(currentItem)" [title]="'assetShared.attachments.download' | transloco">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8.00016 10.6665L10.6668 7.33317H8.66683V2.6665H7.3335V7.33317H5.3335L8.00016 10.6665Z" fill="#4D4749"/>
          <path d="M13.3335 12.0002H2.66683V7.3335H1.3335V12.0002C1.3335 12.7355 1.9315 13.3335 2.66683 13.3335H13.3335C14.0688 13.3335 14.6668 12.7355 14.6668 12.0002V7.3335H13.3335V12.0002Z" fill="#4D4749"/>
        </svg>
      </button>

      <button
        class="photos-modal__fullscreen"
        (click)="toggleFullscreen(mediaStage)"
        [title]="(isFullscreen ? 'assetShared.attachments.exitFullscreen' : 'assetShared.attachments.viewFullscreen') | transloco">
        <i [class]="isFullscreen ? 'ph ph-corners-in' : 'ph ph-corners-out'"></i>
      </button>

      @if (items.length > 1) {
        <button class="photos-modal__nav photos-modal__nav--prev" (click)="previous()" [title]="'assetShared.attachments.previous' | transloco">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8.8618 4.19531L5.05713 7.99998L8.8618 11.8046L9.80446 10.862L6.94246 7.99998L9.80446 5.13798L8.8618 4.19531Z" fill="#4D4749"/>
          </svg>
        </button>
        <button class="photos-modal__nav photos-modal__nav--next" (click)="next()" [title]="'assetShared.attachments.next' | transloco">
          <svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none">
            <path d="M0.942666 7.60933L4.74733 3.80467L0.942666 0L0 0.942666L2.862 3.80467L0 6.66667L0.942666 7.60933Z" fill="#4D4749"/>
          </svg>
        </button>
      }
    </div>

    <p class="photos-modal__counter">{{ 'assetShared.attachments.counter' | transloco: { current: currentIndex + 1, total: items.length } }}</p>

    <div class="photos-modal__thumbnails">
      @for (item of items; track item.reference; let i = $index) {
        <button
          class="photos-modal__thumbnail"
          [class.photos-modal__thumbnail--active]="i === currentIndex"
          (click)="selectItem(i)">
          @if (isThumbnailLoading(item)) {
            <span class="photos-modal__thumbnail-spinner" [attr.aria-label]="'assetShared.attachments.loadingThumbnail' | transloco">
              <span class="photos-modal__spinner-ring photos-modal__spinner-ring--small"></span>
            </span>
          }
          @if (isVideo(item)) {
            <span class="photos-modal__thumbnail-video">
              <i class="ph ph-play"></i>
            </span>
          } @else if (isImage(item)) {
            <img
              [class.photos-modal__thumbnail-image--loading]="isThumbnailLoading(item)"
              [src]="item.url"
              [alt]="item.name"
              (load)="markThumbnailReady(item)"
              (error)="markThumbnailReady(item)" />
          } @else {
            <span class="photos-modal__thumbnail-file">
              <i class="ph ph-file"></i>
            </span>
          }
        </button>
      }
    </div>

    @if (hasReporterDetails) {
      <div class="photos-modal__reporter">
        <app-avatar
          [imageSrc]="reportedByProfilePictureUrl ?? null"
          [name]="reportedBy || ('common.unknown' | transloco)"
          [size]="32">
        </app-avatar>
        <span class="photos-modal__reporter-text">
          {{ 'assetShared.attachments.reportedBy' | transloco }} <span class="photos-modal__reporter-name">{{ reportedBy || ('common.unknown' | transloco) }}</span>
          @if (reportedAtLabel) {
            <span class="photos-modal__reporter-dot">•</span>
            <span class="photos-modal__reported-at">{{ reportedAtLabel }}</span>
          }
        </span>
      </div>
    }

    @if (hasUploaderDetails) {
      <div class="photos-modal__uploader">
        <app-avatar
          [imageSrc]="currentItem.uploaderProfilePictureUrl ?? null"
          [name]="uploaderName"
          [size]="32">
        </app-avatar>
        <span class="photos-modal__uploader-text">
          {{ 'assetShared.attachments.uploadedBy' | transloco }} <span class="photos-modal__uploader-name">{{ uploaderName }}</span>
          @if (uploadedAtLabel) {
            <span class="photos-modal__uploader-dot">•</span>
            <span class="photos-modal__uploaded-at">{{ uploadedAtLabel }}</span>
          }
        </span>
      </div>
    }
  } @else {
    <div class="photos-modal__empty">
      <p>{{ 'assetShared.attachments.empty' | transloco }}</p>
    </div>
  }

  <div class="photos-modal__actions">
    <button class="photos-modal__btn photos-modal__btn--secondary" (click)="close()">{{ 'common.close' | transloco }}</button>
    <button
      class="photos-modal__btn photos-modal__btn--primary"
      [disabled]="items.length === 0 || isDownloading"
      (click)="downloadAll()">
      {{ (isDownloading ? 'assetShared.attachments.downloading' : 'assetShared.attachments.downloadAll') | transloco }}
    </button>
  </div>
</div>
